import React, { useState, useEffect, useRef } from "react";
import KickImage from 'Reuseables/KickImage';
import { Form } from 'reactstrap';
import UserVerificationPhone from "../../../images/user-verification.png"
import { IconContext } from 'react-icons';
import { GrClose, GrFormPreviousLink, GrFormNext } from 'react-icons/gr';
import UserVerificationSMS from "../../../images/mail-user-verification.png"
import UserVerificationCall from "../../../images/call-user-verification.png"
import PhoneVerify from "../../../images/phone-verify.png"
import PhoneOnHand from "../../../images/phone-on-hand.png"
import { toast } from 'react-toastify';
import moment from 'moment'
import Countdown from "react-countdown";
import InputNumber from "Reuseables/InputNumber/InputNumber";

const errorMessage = (message) => {
  switch (message) {
    case 'Request failed with status code 403':
    case '403 Forbidden':
      return 'Please check your e-mail to verify your account. Simply click the link given on the email to complete this process.';
    case 'Request failed with status code 502':
      return 'The phone number has been already registered'
    case 'Request failed with status code 501':
      return 'The code you entered is incorrect'
    case 'Client error: `POST http://104.199.196.122/gateway/v3/smsotp` resulted in a `401 Unauthorized` response:\n{\"rc\":98,\"info\":\"Authorization failed\"}\n':
      return 'Internal server error'
    default:
      return message
  }
};

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  const waitSeconds = days * 24 + hours;
  return (
    <span>
      Wait for {seconds} seconds
    </span>
  );
};

const ModalInputPhoneNumber = (props) => {

  const [phoneNumber, setPhoneNumber] = useState('')
  const [countryCode, setCountryCode] = useState("")
  const [submitDisabled, setSubmitDisabled] = useState(true)

  useEffect(() => {
    if (phoneNumber && phoneNumber.length > 5) {
      setSubmitDisabled(false)
    } else {
      setSubmitDisabled(true)
    }
  }, [phoneNumber])

  useEffect(() => {
    if (props.isExistingSeller) {
      setPhoneNumber('')
    } else {
      if (props.phone) {
        setPhoneNumber(props.phone.replace("+62", ""))
      }
    }
  }, [props.isExistingSeller])

  function handleInputPhoneNumber(e) {
    const phoneInput = e.target.value.replace(/\D/, '')
    if (props.isExistingSeller) {
      props.setPhone(phoneInput)
      setPhoneNumber(phoneInput)
    } else {
      setPhoneNumber(phoneInput)
    }
  }

  function handleSelectInputCountryCode(e) {
    setCountryCode(e.target.value)
  }

  function submit() {
    const { ...additionalPayloadPhone } = props.payloadSubmitPhone;
    const payload = {
      mobile_number: `+62${phoneNumber}`,
      ...additionalPayloadPhone
    }

    props.doSubmitPhone(payload)
      .then(({ value }) => {
        props.setPhoneId(value.data.id)
        props.setSlug("verification-method")
      })
      .catch(e => {
        const message = props.dataPhone?.error?.message ?? e.message
        return toast.error(errorMessage(message), {
          position: 'top-right',
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        })
      })
  }

  return <div className="phone-number__Container">
    <div onClick={props.toggle} className="close-icon__Container">
      <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
        <div>
          <GrClose />
        </div>
      </IconContext.Provider>
    </div>
    <div className="content__Container">
      <KickImage src={UserVerificationPhone} alt="User Verification" />
      <p>Are you sure you have entered the right number?</p>
    </div>
    <div className="input__Container">
      <select value={countryCode} onChange={handleSelectInputCountryCode}>
        <option value={"+62"}>+62</option>
        <option value={"+65"}>+65</option>
        <option value={"+60"}>+60</option>
      </select>
      <InputNumber onChange={handleInputPhoneNumber} value={phoneNumber} placeholder="Phone Number" />
    </div>
    <div onClick={submitDisabled ? null : () => submit()} className={`button__Container ${submitDisabled ? "isDisabled" : ""}`}>
      <p>Submit</p>
    </div>
  </div>
}

const ModalVerificationMethod = (props) => {

  function backToPhoneInput() {
    props.setSlug("input-phone-number")
  }

  function messageSubmit() {
    props.doSentSMS({ id: props.phoneId })
      .then(_ => {
        props.setVerificationMethod('sms')
        props.setSlug("verification-code")
      })
      .catch(e => {
        const message = props.dataSms?.message ? props.dataSms?.message : e?.response?.data?.error?.message
        return toast.error(message, {
          position: 'top-right',
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        })
      })
  }

  function callSubmit() {
    props.doSentCitCall({ id: props.phoneId })
      .then(_ => {
        props.setVerificationMethod('citcall')
        props.setSlug("verification-code")
      })
      .catch(e => console.log(e))
  }

  return <div className="verification-method__Container">
    <div onClick={props.toggle} className="close-icon__Container">
      <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
        <div>
          <GrClose />
        </div>
      </IconContext.Provider>
    </div>
    <div onClick={() => backToPhoneInput()} className="back-icon__Container">
      <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
        <div>
          <GrFormPreviousLink />
        </div>
      </IconContext.Provider>
    </div>
    <div className="content-description__Container">
      <h4>Verification Method</h4>
      <p>Choose one of the methods below to get <br />a verification code</p>
    </div>
    <div className="content-verification__Container">
      <div onClick={() => messageSubmit()} className="sms__Container">
        <div className="sms">
          <KickImage src={UserVerificationSMS} alt="sms.." />
          <p>SMS</p>
        </div>
        <div>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <GrFormNext />
            </div>
          </IconContext.Provider>
        </div>
      </div>
      <div onClick={() => callSubmit()} className="mail__Container">
        <div className="mail">
          <KickImage src={UserVerificationCall} alt="mail.." />
          <p>Missed Call</p>
        </div>
        <div>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <GrFormNext />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </div>
  </div>
}

const ModalVerificationCode = (props) => {

  const [firstInput, setFirstInput] = useState(null)
  const [secondInput, setSecondInput] = useState(null)
  const [thirdInput, setThirdInput] = useState(null)
  const [forthInput, setForthInput] = useState(null)
  const [fifthInput, setFifthInput] = useState(null)
  const [sixthInput, setSixthInput] = useState(null)

  const [errorMsg, setErrorMsg] = useState('')

  const firstInputRef = useRef()
  const secondInputRef = useRef()
  const thirdInputRef = useRef()
  const forthInputRef = useRef()
  const fifthInputRef = useRef()
  const sixthInputRef = useRef()

  const [submitDisabled, setSubmitDisabled] = useState(true)

  //timer
  const [callResendCode, setCallResendCode] = useState(30);
  const [smsResendCode, setSmsResendCode] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setCallResendCode(callResendCode => callResendCode - 1);
    }, 1000);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSmsResendCode(smsResendCode => smsResendCode - 1);
    }, 1000);
  }, []);
  //end timer

  useEffect(() => {
    if (firstInput && secondInput && thirdInput && forthInput && fifthInput && sixthInput) {
      setSubmitDisabled(false)
    } else {
      setSubmitDisabled(true)
    }
  }, [firstInput, secondInput, thirdInput, forthInput, fifthInput, sixthInput])

  function handleFirstInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setFirstInput(inputValue)
    if (inputValue) {
      secondInputRef.current.focus()
    }
  }

  function handleSecondInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setSecondInput(inputValue)
    if (inputValue) {
      thirdInputRef.current.focus()
    } else {
      firstInputRef.current.focus()
    }
  }

  function handleThirdInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setThirdInput(inputValue)
    if (inputValue) {
      forthInputRef.current.focus()
    } else {
      secondInputRef.current.focus()
    }
  }

  function handleForthInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setForthInput(inputValue)
    if (inputValue) {
      fifthInputRef.current.focus()
    } else {
      thirdInputRef.current.focus()
    }
  }

  function handleFifthInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setFifthInput(inputValue)
    if (inputValue) {
      sixthInputRef.current.focus()
    } else {
      forthInputRef.current.focus()
    }
  }

  function handleSixthInput(e) {
    const inputValue = e.target.value.replace(/[^\d]/g, "")
    setSixthInput(inputValue)
    if (!inputValue) {
      fifthInputRef.current.focus()
    }
  }

  function submitOtp() {
    const otpCode = `${firstInput + secondInput + thirdInput + forthInput + fifthInput + sixthInput}`
    const payload = {
      mobile_number: `+62${props.phone}`,
      code: otpCode,
      name: props.dataPhoneUser.name,
      id: props.dataPhoneUser.id,
      verify_type: props.verificationMethod
    }
    props.checkOtpCode(payload)
      .then(({ value }) => {
        props.doRefreshToken()
      })
      .then(_ => {
        props.setSlug('success-screen')
      })
      .catch(e => {
        const message = props.dataVerify?.error?.message ?? e.message
        return toast.error(errorMessage(message), {
          position: 'top-right',
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
        })
      })
  }

  function resendCode() {
    if (props.verificationMethod === "sms") {
      props.doSentSMS({ id: props.phoneId })
        .then(({ value }) => {
          if (value.status_code === 200) {
            setSmsResendCode(60);
          } else {
            return toast.error(value.message, {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            })
          }
        })
        .catch(e => {
          return toast.error("Something went wrong!", {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          })
        })
    } else {
      props.doSentCitCall({ id: props.phoneId })
        .then(({ value }) => {
          if (value.status_code !== 200) {
            return toast.error(value.message, {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            })
          } else {
            setCallResendCode(30);
          }
        })
        .catch(e => {
          return toast.error("Something went wrong!", {
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
          })
        })
    }
  }

  const convertNumber = props.dataPhoneUser.mobile_number.replace("+62", "0")
  const splitNumber = convertNumber.match(/.{1,4}/g).join("-")
  const phoneNumber = splitNumber.replace("0", "+62")

  if (props.verificationMethod === "sms") {
    return <Form onSubmit={!submitDisabled ? () => submitOtp() : null}>
      <div className="verification-code__Container">
        <div onClick={props.toggle} className="close-icon__Container">
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
        <div onClick={() => props.setSlug("verification-method")} className="back-icon__Container">
          <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
            <div>
              <GrFormPreviousLink />
            </div>
          </IconContext.Provider>
        </div>
        <div className="image__Container">
          <KickImage alt="phone.." src={UserVerificationPhone} />
        </div>
        <div className="info__Container">
          <h4>We will send the verification code to</h4>
          <p>{phoneNumber}</p>
        </div>
        <div className="input__Container">
          <input ref={firstInputRef} type="text" maxlength="1" value={firstInput} onChange={handleFirstInput} />
          <input ref={secondInputRef} type="text" maxlength="1" value={secondInput} onChange={handleSecondInput} />
          <input ref={thirdInputRef} type="text" maxlength="1" value={thirdInput} onChange={handleThirdInput} />
          <input ref={forthInputRef} type="text" maxlength="1" value={forthInput} onChange={handleForthInput} />
          <input ref={fifthInputRef} type="text" maxlength="1" value={fifthInput} onChange={handleFifthInput} />
          <input ref={sixthInputRef} type="text" maxlength="1" value={sixthInput} onChange={handleSixthInput} onKeyPress={!submitDisabled ? () => submitOtp() : null} />
        </div>
        <div className="resend__Container">
          <p>Haven't got the code yet? {
            smsResendCode <= 0 ?
              <span onClick={() => resendCode()}> Resend code</span>
              : `Wait ${smsResendCode} seconds`
          } </p>
        </div>
        <div onClick={!submitDisabled ? () => submitOtp() : null} className={`submit__Container ${submitDisabled ? 'isDisabled' : ""}`}>
          <p>Submit</p>
        </div>
        <div className="changeMethod__Container">
          <p onClick={() => props.setVerificationMethod("citcall")}>Miss call me instead</p>
        </div>
      </div>
    </Form>
  } else {
    return <Form onSubmit={!submitDisabled ? () => submitOtp() : null}>
      <div className="verification-code__Container">
        <div onClick={props.toggle} className="close-icon__Container">
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
        <div onClick={() => props.setSlug("verification-method")} className="back-icon__Container">
          <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
            <div>
              <GrFormPreviousLink />
            </div>
          </IconContext.Provider>
        </div>
        <div className="image__Container">
          <KickImage alt="phone.." src={UserVerificationPhone} />
        </div>
        <div className="info__Container">
          <h4>Enter the last 6 digit miss called number</h4>
          <p>We will miss call you at {phoneNumber}</p>
        </div>
        <div className="input__Container">
          <input ref={firstInputRef} type="text" maxlength="1" value={firstInput} onChange={handleFirstInput} />
          <input ref={secondInputRef} type="text" maxlength="1" value={secondInput} onChange={handleSecondInput} />
          <input ref={thirdInputRef} type="text" maxlength="1" value={thirdInput} onChange={handleThirdInput} />
          <input ref={forthInputRef} type="text" maxlength="1" value={forthInput} onChange={handleForthInput} />
          <input ref={fifthInputRef} type="text" maxlength="1" value={fifthInput} onChange={handleFifthInput} />
          <input ref={sixthInputRef} type="text" maxlength="1" value={sixthInput} onChange={handleSixthInput} onKeyPress={!submitDisabled ? () => submitOtp() : null} />
        </div>
        <div className="resend__Container">
          <p>Haven't got miss call yet? {
            callResendCode <= 0 ?
              <span onClick={() => resendCode()}> Miss call me again</span> :
              `Wait ${callResendCode} seconds`
          } </p>
        </div>
        <div onClick={!submitDisabled ? () => submitOtp() : null} className={`submit__Container ${submitDisabled ? 'isDisabled' : ""}`}>
          <p>Submit</p>
        </div>
        <div className="changeMethod__Container">
          <p onClick={() => props.setVerificationMethod("sms")}>Message me instead</p>
        </div>
      </div>
    </Form>
  }
}

const ModalSuccessScreen = (props) => {
  const onClickStartSelling = async () => {
    if (props.fetchProfile) {
      await props.fetchProfile();
    }
    props.history.push('/sell-request');
  }

  return (
    <div className="success-screen__Container">
      <div onClick={props.toggle} className="close-icon__Container">
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
      <div className="image__Container">
        <KickImage alt="Success.." src={PhoneOnHand} />
      </div>
      <div className="text__Container">
        <h4>You are now a seller!</h4>
        <p>Your account has been verified successfully.
          You can start selling your product.</p>
      </div>
      <div onClick={onClickStartSelling} className="button__Container">
        <p>Start Selling</p>
      </div>
    </div>
  )
}

const ModalExisitingSeller = (props) => {
  return (
    <div className="existing-seller__Container">
      <div onClick={props.toggleExistingModal} className="close-icon__Container">
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
      <div className='existing-seller__Section'>
        <KickImage alth="phone verify.." src={PhoneVerify} />
        <div className="existing-seller__description">
          <h4>Please verify your phone number.</h4>
          <p>You have to verify your phone number to continue <br /> selling in our platform</p>
        </div>
        <div className="existing-seller__verification">
          <div onClick={() => {
            props.history.push('/seller-registration')
          }} className="verify-now">
            <p>Verify now</p>
          </div>
          <div onClick={props.toggleExistingModal} className="verify-later">
            <p>Verify Later</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export {
  ModalInputPhoneNumber,
  ModalVerificationMethod,
  ModalVerificationCode,
  ModalSuccessScreen,
  ModalExisitingSeller
}